import OpenQueryReminders from "./OpenQueryReminders-container";

export default OpenQueryReminders;